import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";

/** Link in a chain */
var Link = /*#__PURE__*/_createClass(function Link() {
  _classCallCheck(this, Link);

  this.children = new WeakMap();
});

var KeySize = /*#__PURE__*/function (_Error) {
  _inherits(KeySize, _Error);

  var _super = _createSuper(KeySize);

  function KeySize() {
    var _this;

    _classCallCheck(this, KeySize);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.message = 'Keys must include at least one member';
    return _this;
  }

  return _createClass(KeySize);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Maps from a list of objects (referentially) to any value
 *
 * If *any* members of the list get claned up, so does that key/value pair get removed.
 */


var WeakListMap = /*#__PURE__*/function () {
  function WeakListMap() {
    _classCallCheck(this, WeakListMap);

    this.first = new WeakMap();
  }

  _createClass(WeakListMap, [{
    key: "delete",
    value: function _delete(key) {
      var link = this.traverse(key);
      link == null ? true : delete link.value;
      return !!link;
    }
  }, {
    key: "get",
    value: function get(key) {
      var link = this.traverse(key);
      return link == null ? void 0 : link.value;
    }
  }, {
    key: "has",
    value: function has(key) {
      var link = this.traverse(key);
      if (!link) return false;
      return Object.prototype.hasOwnProperty.call(link, 'value');
    }
  }, {
    key: "set",
    value: function set(key, value) {
      if (key.length < 1) throw new KeySize();
      var cur = this.first;
      var link;

      for (var i = 0; i < key.length; i++) {
        if (!cur.has(key[i])) {
          link = new Link();
          cur.set(key[i], link);
        } else {
          link = cur.get(key[i]);
        }

        cur = link.children; // do on later iteration of loop. this makes typescript happy rather than putting after loop

        if (i === key.length - 1) {
          link.value = value;
        }
      }

      return this;
    }
  }, {
    key: "traverse",
    value: function traverse(key) {
      var cur = this.first;
      var link;

      for (var i = 0; i < key.length; i++) {
        link = cur.get(key[i]);
        if (!link) return;
        cur = link.children;
      }

      return link;
    }
  }]);

  return WeakListMap;
}();

export { WeakListMap as default };